import checkmark from '../../images/checkmark.png';
import Button from '../PendantButton';
import { COLOR } from '../shared/shared';
import React from 'react';

// DUPLICATED IN BOX ERECTOR PAGE -- CLEAN UP
export const lWhiteStyle: string =
	'invert(100%) sepia(0%) saturate(7479%) hue-rotate(70deg) brightness(99%) contrast(107%)';

interface CheckBoxProps {
	pCompleted: boolean;
	pActive: boolean;
	pText: string;
	pIndex: number;
	pHandleClick: (pIndex: number) => void;
	pHideBackground?: boolean;
}

export default function CheckBox({
	pCompleted,
	pActive,
	pText,
	pIndex,
	pHandleClick,
	pHideBackground,
}: CheckBoxProps) {
	return (
		<Button
			pAction={() => pHandleClick(pIndex)}
			pNormalColorOverride={pHideBackground ? COLOR.TRANSPARENT : COLOR.SILVER}
			pClickColorOverride={COLOR.TRANSPARENT}
			pClass={`vh-8 full-width margin-bottom ${
				pActive && !pHideBackground ? 'blue-inner-border' : ''
			}`}
		>
			<div className="full-width flex-row flex-start align-center padding-left">
				<div
					className={`fully-round ${
						pCompleted ? 'background-green' : 'background-silver inner-border'
					} square center vw-2`}
				>
					{pCompleted && (
						<img
							className="auto-height width-100"
							style={{ filter: lWhiteStyle }}
							src={checkmark}
							alt="checkmark"
						/>
					)}
					{!pCompleted && <div className="full-size"></div>}
				</div>
				<span
					className={`color-blue ${
						pActive ? 'bold-font ' : ' '
					} font-5 text-align-left`}
				>
					{pText}
				</span>
			</div>
		</Button>
	);
}
